<div class="clearfix" [formGroup]="dateForm">
    <label class="sr-only">Day (DD)</label>
    <input required inputmode="numeric" max="31" maxlength="2" type="number" placeholder="DD" formControlName="day"
        class="form-control" />
    <label class="sr-only">Month (MM)</label>
    <input required inputmode="numeric" max="12" maxlength="2" type="number" placeholder="MM" formControlName="month"
        class="form-control" />
    <label class="sr-only">Year (YYYY)</label>
    <input required inputmode="numeric" [min]="minYear" [max]="maxYear" maxlength="4" type="number" placeholder="YYYY"
        formControlName="year" class="form-control" />
</div>